export enum SubscriptionCardTypes {
  PLAN_SMART_ALARM_BASIC = 'PLAN_SMART_ALARM_BASIC',
  PLAN_SMART_RADAR_BASIC = 'PLAN_SMART_RADAR_BASIC',
  PLAN_SMART_RADAR_ADVANCED = 'PLAN_SMART_RADAR_ADVANCED',
  PLAN_SMART_RADAR_PREMIUM = 'PLAN_SMART_RADAR_PREMIUM',
  PLAN_SMART_RADAR_INCLUDED = 'PLAN_SMART_RADAR_INCLUDED',
}
